export default {
    common: {
        unit: 'USDT',
        day: '天',
        week: '周',
        save: '保存',
        submit: '提交',
        confirmtitle: '确定执行操作',
        confirm: '确认',
        reset: '重置',
        refresh: '刷新',
        copy: '复制',
        copysuccessful: '复制成功',
        modify: '修改',
        binding: '绑定',
        finished: '已完成',
        canceled: '已取消',
        cancel: '取消',
        all: '全部',
        back: '返回',
        loading: '加载中...',
        nomore: '所有记录',
        errortxt: '加载失败',
        loosing: '释放即可刷新...',
        pulling: '下拉即可刷新...',
        nodata: '暂时没有记录',
        buy: '买入',
        buyup: '买涨',
        buydown: '买跌',
        sell: '卖出',
        forserver: '请咨询客服',
        total: '合计',
        status1: '待审核 ',
        status2: '完成 ',
        status3: '未通过',
        paytype1:'TRC20',
        paytype2: 'ERC20', 
        paytype3: '电汇',
    },
   
    
    market:{
        title: '行情',
        all: '全部'
    },
    member:{
        reputation:'信誉分',
        identity_authentication:'身份认证',
        under_review:'审核中',
        certified:'已认证',
        awaiting_certification:'待认证',
        binding_withdrawal_address: '绑定提币地址',
        currently_selected_currency:'当前选择币种',
        withdrawal_address:'提币地址',
        sharing_link:'我的分享链接',
        my_promotion_code:'我的推广码',
        promotion_code:'推广码',
        system_message:'系统消息',
        night_mode:'夜间模式',
        security_center:'安全中心',
        seted: '已设置',
        noset: '未设置',
        login_password:'登录密码',
        transaction_password:'提现密码',
        app_download:'App 下载',
        log_out:'退出登录',
        aboutus: '网站介绍'
    },
    identity:{
        title: '身份认证',
        name: '姓名',
        nameplaceholder: '请输入真实姓名',
        uploader: '上传身份证照片',
        tip1: '上传身份证正面',
        tip2: '上传身份证反面'
    },
    address: {
        title: '绑定提币地址',
        bType: '当前选择币种',
        address: '提币地址',
        addressplaceholder:'请输入提币地址',
    },
    security:{
        title: '安全中心',
        modifypwd: '登录密码',
        resetlegalpwd: '交易密码',
        loginpwd: '新登录密码',
        pwdage: '确认密码',
        loginpwdplaceholder:'请输入当前登录密码',
        loginnewpwdplaceholder: '请输入新的登录密码',
        moneypwd: '请输入交易密码',
        pwdageplaceholder:'请再次输入密码'
    },
    
    assets:{
        allconvert:'总资产折合',
        usenum: '可用',
        freeze: '冻结',
        convert: '折合',
        tab1:'资产',
        tab11: '总资产折合',
        tab12: '期权折合',
        tab13: '资金折合',
        tab14: '量化折合',
        tab2:'期权',
        tab21: '期权账户',
        tab3:'资金',
        tab31:'资金账户',
        tab4:'量化',
        tab41:'量化账户',
        tbhead1: '财务记录',
        tbhead2: '提币记录',
        tbhead3: '充币记录',
        tbhead4: '划转记录',
        rcdnum: '数量',
        rcd: '记录',
        rcdtime: '时间' ,
        rcdstatus: '状态',
        rcddesc: '备注',
        rcdaddress: '充币地址'
    },
    change:{
        title: '划转',
        from: '从 {name}',
        to: '到 {name}',
        frmtitle: '划转数量',
        inputplaceholder: '请输入划转数量',
        btntxt:'划转'
    },
   
    exchangeb:{
        title: '兑换',
        account: '账户',
        btn: '兑换',
        numerror: '请输入兑换数量'
    },
    
    tradelst:{
        title: '我的委托',
        tab1: '委托',
        tab2: '交易完成',
        tab3: '已撤销',
        usdtnum: ''
    },
    loans:{
        title: '助力贷',
        order_tab: '贷款订单',
        pro_tab: '贷款产品',

        Institution:'放款机构',
        Amount: '金额',
        DailyInterest:'日利率',
        RepaymentPeriod:'还款周期',
        Application: '申请贷款',
        orderno: '订单号',
        AllInterest: '总利息',
        RepaymentDate:'还款日期',
        RepaymentMethod: '还款方式',
        Onetime: '一次性',
        Expected_loan_amount:'期望借款金额',
        Expected_loan_amounterror:'借款金额范围在 {min} - {max} 之间',
        imgplaceholdr: '信用放贷(请确保图片清晰可见)',
        icon1: '上传证件正面',
        icon2: '上传证件反面',
        icon3: '上传手持证件',
        status1: '申请中',
        status2: '申请通过',
        status3: '申请失败',
    },
    lockming:{
        title: '锁仓挖矿',
        order_tab: '矿机订单',
        pro_tab: '矿机市场',
        locknum: '最小锁仓数量',
        getforday: '收益率/天数',
        days: '天数',
        estimation: '预估收益',
        real: '已收益',
        balance: '钱包余额',
        nums: '锁仓数量',
        tolockming: '锁仓',
        stime: '开始时间',
        etime: '结束时间',
    },
    transfer:{
        title: '账户转账',
        searchtxt: '请输入对方账号',
        ReceivingAccount: '收款账户信息',
        toaccount: '账户',
        confirmtxt: '请点击确认收款账户',
        confirmedtxt: '已确认收款账户',
        numtxt: '转账数量',
        numerror: '请输入转账数量',
        fee: '内部转账免手续费',
        ArrivalTime: '到账时间',
        Immediately: '立即到账',
        realnum: '实际到账数量',
        btn: '确认转账',

        transfering: '划转中',
        orderNo: '订单号',
        stime: '划转时间',
        etime: '到账时间',
        receiving: '收款账户',
        type: '币种',
        num: '划转数量',
        arrivalnum: '入账数量'
    },
    staking:{
        title: '质押',
        record: '记录',
        getforyear: '参考年化收益',
        time: '投资期限',
        snum: '起投数量',
        snumerror: '请输入起投数量',
        snumerror1: '起投数量不低于 {num}',
        join: '立即参与',
        opentime: '建仓时间',
        money: '投入金额',
        days: '周期',
        recordget: '年化收益',
        gets: '收益',
        stime: '开始日期',
        etiem: '结束日期',
        redeemStaking: '撤销',
        status0: '质押中',
        status1: '订单结束',
        status2: '订单赎回',
    },
    bank:{
        title: '绑定银行卡',
        bankName: '银行名称',
        bankNameError: '请输入银行名称',
        usrName: '持卡人',
        usrNameError: '请输入持卡人',
        cardCode: '银行卡号',
        cardCodeError: '请输入银行卡号',
        towallet: '提币到钱包',
        tobank: '提币到银行卡',
        sendcode: '发送验证码',
        sended: '{num}秒后重新发送',
        verify_code: '请输入邮箱验证码'
    },
    /***************************/
     register: {
        register: '邮箱注册',
        fotget: '忘记密码',
        login: '欢迎登录',
        email: 'Email',
        accountplaceholder: '请输入账号',
        emailplaceholder: '请输入邮箱',
        phoneplaceholder: '请输入手机',
        pwdplaceholder:'请输入密码',
        pwdplaceholder1:'密码为6-20位任意字母数字',
        agepwdplaceholder: '请再次输入密码',
        agepwdplaceholder1: '两次输入密码不相同',
        invitecodeplaceholder: '请输入邀请码',
        remember: '自动登录',
    },
     recharge:{
        title: '充币',
        bType: '当前币种',
        address: '存款',
        token: '支付凭证',
        tokenplaceholder: '请上传支付凭证',
        num: '存款金额',
        numplaceholder: '请输入数量',
        btn: '存款',
        bankname: '银行名称',
        bankno: '银行号码',
        accountname: '收款账号名称',
        bankaddress: '银行地址',
        bankcode: '银行汇款代码',
        companyaddress: '公司地址'
    },
    withdrawal:{
        title:'提币',
        frmtitle1: '数量',
        frmplaceholder1: '提币数量在 {min} - {max} 之间',
        frmtitle2: '交易密码',
        frmplaceholder2: '请输入交易密码',
        getnum: '到账数量',
        fee:'手续费',
        btn: '提币'
    },
    home: {
        menu1:'期权交易',
        menu1desc: '支持BTC/USDT等',
        menu2: '快捷充值',
        menu3: '提币',
        menu4: '在线客服',
        menu5: '闪兑',
        menu6: '助力贷',
        menu7: '锁仓挖矿',
        menu8: '质押',
        menu9: '账户转账',
        ranktitle: '市场行情',
        name: '交易对',
        price: '最新价',
        risefall: '涨跌',
        accountcenter: '前往资产中心'
    },
     footer: {
        home: '主页',
        market: '行情', 
        exchange: '交易',
        trade: '交易',
        locking: '质押',
        options: '期权',
        assets:'资产',
        change: '划转',
        recharge: '充币',
        withdrawal: '提币'
    },
    trade:{
        title: '币币交易',
        price: '价格',
        num: '数量',
        entrust: '当前委托',
        clinch: '实际成交',
        used: '可用',
        buyed: '可买',
        amount: '交易额',
        limitprice: '限价',
        marketprice: '市价',
        forprice: '以当前最优价格交易',
        errorMoney: '可用余额不足',
        priceerror: '请输入委托价格',
        numerror: '请输入委托数量',
        moneyerror: '请输入委托金额',
    },
    option:{
        title: '期权',
        typetitle: '秒合约',
        listtitle: '持仓',
        kline: 'K线',
        high: '高',
        low: '低',
        nums: '24H量',
        time: '时间',
        transaction: '交易模式',
        quantity: '开仓数量',
        quantityerror: '请输入开仓数量',
        times: '开仓时间',
        times1: '结算时间',
        account: '账户余额',
        buyup:'买涨',
        buydown: '买跌',
        tab1: '持仓列表',
        tab2: '订单记录',
        num: '数量',
        price1: '购买价',
        price2: '成交价',
        profitandloss: '预计盈亏',
        profitandloss1: '盈亏',
        countdown: '倒计时',
        waitfinish: '待结算',
        finishing: '结算中...',
        finished: '已结算',
        order_price: '现价',
        order_cycle: '周期',
        order_type: '类型',
        order_money: '金额',
        order_time: '建仓',
        order_get: '盈利',
        order_btn: '继续下单'
    },
    other:{
        welcome: ' Hi,歡迎來到 {name}',
        homeaboutustitle: '全球领先的一站式数位资产交易平台',
        homeaboutustitle1: '安全保障',
        homeaboutusdesc1: '多家頂級安全機构通力合作保證用戶交易安全且高效',
        homeaboutustitle2: '7x24小時客服',
        homeaboutusdesc2: '24小時線上客服，隨時響應您的需求',
        homeaboutustitle3: '全球化覆蓋',
        homeaboutusdesc3: '國際化社區社群，覆蓋全球205個國家地區支持11種語言，19種國家地區社群，500萬註冊用戶',
        totrade: '开始交易',
        toregister: '开启数字货币之旅',
        yingli: '今日盈利',
        kuisun: '今日亏损',
        agree: '我已已读并同意',
        useragreement:'用户协议',
        account: '账号',
        pwd:'密码',
        toregister1: '还没注册',
        loginbtn: '登录',
        registerbtn: '立即注册',
        tologin: '已有账号，前往注册',
        allrevenue:'总收益',
        stakingcount: '质押订单',
        stakingamount: '质押金额',
        todayincome: '今日预估',
        verify_code:'验证码',
        pwdage: '确认密码',
        invitecode: '邀请码',

        title: '协议条款',
        h3: '使用条款',
        contexts: 'KKDA与用户确认:‌',
        contexts1: '一、用户点击KDA注册页面的【同意注册】按钮、完成注册流程并获得KDA账号密码后，即视为用户与KDA达成《用户协议》（以下简称“本协议”），用户进入KDA平台并使用其交易服务的行为均符合本协议规定。',
        contexts2: '二、KDA与用户已仔细阅读《用户协议》全部条款及KDA发布的免责声明、运营规则等内容，确认知悉、理解并接受本协议及前述服务条款、免责声明与运营规则，同意以其作为确定双方权利义务的依据。KDA的《免责声明》为本协议不可分割的组成部分，用户接受本协议即视为同时接受《免责声明》全部内容。本协议内容包含协议正文及KDA未来可能发布或已发布的各类规则、声明、说明文件；所有规则、声明及说明文件均为本协议组成部分，与协议正文具有同等法律效力。',
        contexts3: '三、本协议不涉及KDA用户之间因数字货币交易产生的法律关系及法律纠纷。'
     
    }
}
